import { Button, Space, TableColumnType } from "antd"
import React from "react"
import { useSelector } from "react-redux"
import {selectIsGray, selectTenantCityCode, selectTenantId} from "../../../app/applicationSlice"

export const InformedConsentPrintColumns = (
  onclick: (action: 'scanTheCodeToSign' | 'print', val: any) => void,
): TableColumnType<any>[] => {

  const cityCode = useSelector(selectTenantCityCode)
  const tenantId = useSelector(selectTenantId)
  const isGray = useSelector(selectIsGray)

  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '4rem',
      fixed: 'left',
      render: (_1, _2, i) => `${i + 1}`,
    },
    {
      title: '模板名称',
      align: 'left',
      dataIndex: 'templateName',
      width: '18rem',
      ellipsis: true,
    },

    {
      title: '操作',
      align: 'center',
      width: '6rem',
      render: function action(_, t) {
        return (
          <Space>
            {isGray != 1 &&
              <Button
                type='link'
                size='small'
                onClick={() => {
                  onclick('scanTheCodeToSign', t)
                }}
              >
                {t?.isSign == '1' ? '已签名' : '扫码签名'}
              </Button>
            }

            <Button 
              type='link' 
              size='small' 
              onClick={() => {
                onclick('print', t)
              }}>
              打印
            </Button>
          </Space>
        )
      },
    },
  ]
}